module.exports = __webpack_public_path__ + "static/media/galerija_2017 (30).4cdcad23.jpg";